module.exports = "https://cdn.realtymogul.com/static/media/img_panel_sitevisit.2a7c5f3c.jpg";